import React from "react";

export function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 102 82"
    >
      <path
        fill="url(#paint0_linear_4252_16188)"
        d="M5.1 14.442v6.995l3.991-.676v-3.385L47.896 4.139l.887-.303V0l-.879.29L5.1 14.442z"
      ></path>
      <path
        fill="url(#paint1_linear_4252_16188)"
        d="M92.909 14.442v17.602l-3.992-.677V17.375l-39.69-13.54V0l43.682 14.442z"
      ></path>
      <path
        fill="url(#paint2_linear_4252_16188)"
        d="M93.13 67.246V60.25l-3.99.677v3.385L50.334 77.55l-.887.303v3.836l.878-.29L93.13 67.246z"
      ></path>
      <path
        fill="url(#paint3_linear_4252_16188)"
        d="M5.322 67.246v-6.77l3.991.677v3.16l39.691 13.539v3.836L5.322 67.246z"
      ></path>
      <path
        fill="url(#paint4_linear_4252_16188)"
        d="M3.229 57.424c-.138 0-.235-.048-.29-.145a.616.616 0 01-.083-.31c.014-.235.07-.366.166-.393.096-.028.214-.042.351-.042.373 0 .655-.075.849-.227.193-.152.344-.352.455-.6.124-.248.241-.504.351-.766l3.62-8.564c.138-.33.166-.579.083-.744a.692.692 0 00-.414-.373 2.904 2.904 0 00-.64-.186 2.848 2.848 0 01-.415-.103c-.068-.042-.103-.166-.103-.373 0-.234.083-.358.248-.372.166-.028.359-.041.58-.041.565 0 1.048.055 1.448.165.4.11.744.324 1.034.641.29.304.558.766.807 1.386l3.475 8.564c.097.235.2.476.31.724.11.249.255.456.435.621.193.152.434.235.724.248.151 0 .269.014.351.042.097.027.152.158.166.393 0 .11-.035.213-.104.31-.055.097-.144.145-.268.145a56.667 56.667 0 00-1.159-.062H14.09c-.814 0-1.669.02-2.565.062-.138 0-.235-.048-.29-.145a.615.615 0 01-.082-.31c.013-.235.069-.366.165-.393.097-.028.214-.042.352-.042.675 0 1.04-.124 1.096-.372.069-.248.007-.655-.186-1.22l-.703-1.718h-5.11c-.207.525-.359.904-.455 1.138a15.47 15.47 0 01-.166.455c-.013.07-.027.11-.041.124-.152.47-.234.821-.248 1.055 0 .221.11.366.33.435.235.069.621.103 1.16.103.15 0 .268.014.35.042.097.027.153.158.166.393 0 .11-.034.213-.103.31-.055.097-.145.145-.269.145a56.68 56.68 0 00-1.158-.062H4.532c-.18.014-.366.02-.559.02a29.91 29.91 0 01-.744.042zm3.93-5.089h4.344l-2.09-5.316h-.061l-2.193 5.316zm16.16 5.44c-1.104 0-2.028-.192-2.772-.579-.745-.386-1.304-.882-1.676-1.49a3.62 3.62 0 01-.559-1.923V46.73c0-.262-.027-.51-.082-.745a.966.966 0 00-.331-.6c-.18-.165-.49-.248-.931-.248-.138 0-.255-.014-.352-.041-.096-.028-.152-.159-.165-.393 0-.11.027-.214.082-.31.056-.097.152-.145.29-.145.441.013.855.027 1.241.041.386.014.786.02 1.2.02.841 0 1.703-.02 2.586-.061.138 0 .234.048.29.144.055.097.082.2.082.31-.014.208-.055.332-.124.373a.566.566 0 01-.29.062c-.468 0-.806.076-1.013.228a.854.854 0 00-.352.579 6.278 6.278 0 00-.083.786v6.454c0 .359.035.738.104 1.138.083.386.234.752.455 1.096.22.331.545.607.972.828.442.207 1.028.31 1.759.31.937 0 1.655-.152 2.15-.455.511-.317.863-.71 1.056-1.18.193-.468.29-.95.29-1.447v-5.44c0-.911-.035-1.566-.104-1.966-.069-.414-.22-.669-.455-.765-.22-.11-.565-.166-1.034-.166-.138 0-.255-.014-.352-.041-.096-.028-.152-.159-.166-.393 0-.11.028-.214.083-.31.055-.097.152-.145.29-.145.441.013.834.027 1.179.041.345.014.724.02 1.138.02.413 0 .793-.006 1.137-.02.345-.014.738-.028 1.18-.041.138 0 .234.048.29.144.054.097.082.2.082.31-.014.208-.055.332-.124.373a.566.566 0 01-.29.062c-.372 0-.675.02-.91.062a.779.779 0 00-.517.331c-.11.166-.186.441-.228.828-.027.372-.041.89-.041 1.551v5.772c0 .73-.159 1.358-.476 1.882-.303.524-.71.952-1.22 1.283a5.627 5.627 0 01-1.614.703 6.608 6.608 0 01-1.675.227zm11.165-.351c-.138 0-.235-.048-.29-.145a.615.615 0 01-.083-.31c.014-.235.07-.366.166-.393.096-.028.213-.042.351-.042.442 0 .752-.075.931-.227.18-.166.29-.366.331-.6.055-.248.083-.504.083-.766v-9.867h-1.427c-.47.014-.835.117-1.097.31-.262.18-.455.47-.579.87-.124.385-.234.889-.33 1.51-.015.123-.104.22-.27.289a1.323 1.323 0 01-.455.083.7.7 0 01-.331-.104.342.342 0 01-.165-.31l.062-2.917c0-.193.055-.324.165-.393a.726.726 0 01.393-.103h10.116c.151 0 .276.034.372.103.11.069.166.2.166.393l.082 2.917a.334.334 0 01-.186.31.62.62 0 01-.33.104 1.27 1.27 0 01-.435-.083c-.152-.069-.241-.166-.27-.29-.096-.62-.213-1.124-.35-1.51-.125-.4-.318-.69-.58-.869-.248-.193-.614-.296-1.096-.31H38.02v9.867c.014.262.041.518.083.766.041.234.151.434.33.6.194.151.504.227.932.227.138 0 .255.014.351.042.097.027.152.158.166.393 0 .11-.028.213-.083.31-.055.097-.152.145-.29.145a45.245 45.245 0 00-1.261-.062h-1.18c-.827 0-1.689.02-2.585.062zm16.272.352c-1.007 0-1.917-.187-2.73-.559a6.399 6.399 0 01-2.09-1.51 6.674 6.674 0 01-1.324-2.151 7.224 7.224 0 01-.455-2.545c0-1.145.193-2.158.579-3.04.4-.883.924-1.628 1.572-2.235a6.678 6.678 0 012.13-1.365c.787-.318 1.56-.476 2.318-.476 1.034 0 1.958.186 2.772.558a6.34 6.34 0 012.11 1.51 6.62 6.62 0 011.324 2.173c.303.8.455 1.634.455 2.503 0 1.144-.2 2.158-.6 3.04-.4.883-.931 1.628-1.593 2.235a7.174 7.174 0 01-2.172 1.386 6.01 6.01 0 01-2.296.476zm-.02-.91c.978 0 1.778-.29 2.399-.87.62-.579 1.075-1.337 1.365-2.275.303-.952.455-1.979.455-3.082 0-1.035-.158-1.993-.476-2.876-.303-.896-.765-1.613-1.386-2.151-.62-.552-1.406-.828-2.358-.828-.965 0-1.758.29-2.379.87-.607.565-1.055 1.316-1.345 2.254-.29.924-.434 1.938-.434 3.041 0 1.034.145 2.007.434 2.917.304.896.766 1.62 1.386 2.172.621.552 1.4.827 2.338.827zm8.66.558c-.125 0-.215-.048-.27-.145a.615.615 0 01-.083-.31c.014-.235.07-.366.166-.393.096-.028.214-.042.352-.042.44 0 .751-.075.93-.227.18-.166.29-.366.331-.6.056-.248.083-.504.083-.766V46.73c0-.262-.027-.51-.083-.745a.966.966 0 00-.33-.6c-.18-.165-.49-.248-.931-.248-.138 0-.256-.014-.352-.041-.097-.028-.152-.159-.166-.393 0-.11.028-.214.083-.31.055-.097.145-.145.27-.145.454.013.875.027 1.261.041.386.014.786.02 1.2.02.841 0 1.703-.02 2.586-.061.138 0 .234.048.29.144.054.097.082.2.082.31-.014.235-.069.366-.166.394a1.293 1.293 0 01-.351.041c-.428 0-.738.083-.931.248a.966.966 0 00-.331.6 6.12 6.12 0 00-.083.745v8.523c.014.18.041.372.083.579.041.207.158.38.352.517.206.138.544.2 1.013.186h1.862c.483-.013.848-.09 1.096-.227.262-.152.47-.4.621-.745.152-.345.317-.82.496-1.427a.433.433 0 01.27-.27.919.919 0 01.434-.02.7.7 0 01.33.145c.125.083.18.193.166.33l-.413 2.607c-.042.194-.11.318-.207.373-.083.041-.214.062-.393.062h-8.006c-.386.014-.807.034-1.262.062zm17.7.352c-1.104 0-2.028-.194-2.773-.58-.744-.386-1.303-.882-1.675-1.49a3.62 3.62 0 01-.559-1.923V46.73c0-.262-.027-.51-.083-.745a.966.966 0 00-.33-.6c-.18-.165-.49-.248-.931-.248-.138 0-.256-.014-.352-.041-.097-.028-.152-.159-.166-.393 0-.11.028-.214.083-.31.055-.097.152-.145.29-.145.441.013.855.027 1.24.041.387.014.787.02 1.2.02.842 0 1.704-.02 2.586-.061.138 0 .235.048.29.144.055.097.083.2.083.31-.014.208-.055.332-.124.373a.566.566 0 01-.29.062c-.469 0-.807.076-1.013.228a.854.854 0 00-.352.579 6.278 6.278 0 00-.083.786v6.454c0 .359.035.738.103 1.138.083.386.235.752.456 1.096.22.331.544.607.972.828.441.207 1.027.31 1.758.31.938 0 1.655-.152 2.152-.455.51-.317.862-.71 1.055-1.18.193-.468.29-.95.29-1.447v-5.44c0-.911-.035-1.566-.104-1.966-.07-.414-.22-.669-.455-.765-.22-.11-.566-.166-1.035-.166-.137 0-.255-.014-.351-.041-.097-.028-.152-.159-.166-.393 0-.11.028-.214.083-.31.055-.097.152-.145.29-.145.44.013.834.027 1.179.041.344.014.724.02 1.137.02.414 0 .793-.006 1.138-.02.345-.014.738-.028 1.18-.041.137 0 .234.048.289.144.055.097.083.2.083.31-.014.208-.055.332-.124.373a.566.566 0 01-.29.062c-.372 0-.676.02-.91.062a.779.779 0 00-.517.331c-.11.166-.187.441-.228.828-.028.372-.041.89-.041 1.551v5.772c0 .73-.159 1.358-.476 1.882-.303.524-.71.952-1.22 1.283a5.627 5.627 0 01-1.614.703 6.608 6.608 0 01-1.676.227zm7.979-.352c-.138 0-.235-.048-.29-.145a.615.615 0 01-.083-.31c.014-.235.07-.366.166-.393.096-.028.214-.042.351-.042.359 0 .649-.041.87-.124.22-.082.427-.227.62-.434.207-.207.434-.49.682-.848l3-4.262-2.648-4.158c-.345-.524-.676-.896-.993-1.117a2.95 2.95 0 00-1.138-.496 4.338 4.338 0 01-.413-.104c-.07-.027-.104-.151-.104-.372 0-.234.083-.359.249-.372.165-.028.358-.042.579-.042.648 0 1.2.07 1.655.207a3.22 3.22 0 011.24.683c.373.317.739.738 1.097 1.262l1.697 2.772 2.047-2.98c.304-.454.345-.737.125-.847-.207-.11-.552-.166-1.035-.166-.138 0-.255-.014-.351-.041-.097-.028-.152-.159-.166-.393 0-.11.028-.214.083-.31.055-.097.145-.145.269-.145.441.013.82.027 1.138.041a27.064 27.064 0 002.13 0c.276-.014.635-.028 1.076-.041.138 0 .234.048.29.144.055.097.082.2.082.31-.013.235-.069.366-.165.394-.083.027-.2.041-.352.041-.345 0-.634.041-.869.124a1.61 1.61 0 00-.641.435c-.193.206-.414.49-.662.848l-2.42 3.434 3.6 5.13c.234.345.489.669.765.972.29.304.662.455 1.117.455.151 0 .269.014.351.042.097.027.152.158.166.393 0 .11-.028.213-.083.31-.055.097-.145.145-.269.145a45.257 45.257 0 00-1.262-.062h-1.22c-.786 0-1.628.02-2.524.062-.138 0-.234-.048-.29-.145a.615.615 0 01-.082-.31c.013-.235.069-.366.165-.393.097-.028.214-.042.352-.042.413 0 .676-.103.786-.31.11-.207.069-.441-.124-.703l-2.648-3.786-2.648 3.786c-.303.441-.345.724-.124.848.22.11.565.165 1.034.165.152 0 .27.014.352.042.096.027.152.158.165.393 0 .11-.027.213-.082.31-.056.097-.145.145-.27.145a56.667 56.667 0 00-1.158-.062h-2.13c-.262.014-.614.034-1.055.062z"
      ></path>
      <path
        fill="url(#paint5_linear_4252_16188)"
        d="M47.16 25.729c-8.16-1.445-15.079-.15-17.518.677l35.035 4.964c-2.44-1.279-9.358-4.197-17.518-5.641z"
      ></path>
      <path
        fill="url(#paint6_linear_4252_16188)"
        d="M51.816 36.56c-14.014-.361-24.613-4.212-28.161-6.093 1.41.602 6.71 2.031 16.63 2.934 12.401 1.128 25.5.451 42.352 2.03 13.482 1.265 17.74 6.996 18.183 9.704-1.774-1.128-6.652-3.791-11.974-5.416-6.652-2.03-19.513-2.708-37.03-3.159z"
      ></path>
      <path
        fill="url(#paint7_linear_4252_16188)"
        d="M3.478 30.016c-.665-2.934-6.208-2.934-1.774-2.934 18.846 0 18.625-5.19 39.027-5.867 7.43-.087 13.512 1.5 18.182 3.485 7.453 3.167 11.309 7.347 11.309 7.347s-12.196-8.575-29.491-8.575c-17.296 0-27.718 6.544-27.718 6.544 5.1 3.385 21.287 7.221 21.287 7.221C19 36.334 6.14 30.92 6.14 30.92c-.222 5.415-2.54 5.454-2.869 8.123-.296 2.409-.236 4.288-.236 4.288-2.44-5.416 1.109-10.38.443-13.314z"
      ></path>
      <path
        fill="url(#paint8_linear_4252_16188)"
        d="M49.67 63.185l1.095 3.43h3.544l-2.867 2.12 1.095 3.43-2.867-2.12-2.868 2.12 1.096-3.43-2.868-2.12h3.544l1.096-3.43z"
      ></path>
      <path
        fill="url(#paint9_linear_4252_16188)"
        d="M57.652 63.185l.597 1.87h1.934l-1.564 1.157.597 1.871-1.564-1.156-1.564 1.156.597-1.87-1.564-1.157h1.934l.597-1.871z"
      ></path>
      <path
        fill="url(#paint10_linear_4252_16188)"
        d="M36.365 63.185l.598 1.87h1.933l-1.564 1.157.597 1.871-1.564-1.156-1.564 1.156.598-1.87-1.564-1.157h1.933l.597-1.871z"
      ></path>
      <path
        fill="url(#paint11_linear_4252_16188)"
        d="M63.417 63.185l.598 1.87h1.933l-1.564 1.157.597 1.871-1.564-1.156-1.564 1.156.598-1.87-1.564-1.157h1.933l.597-1.871z"
      ></path>
      <path
        fill="url(#paint12_linear_4252_16188)"
        d="M42.13 63.185l.597 1.87h1.934l-1.564 1.157.597 1.871-1.564-1.156-1.564 1.156.597-1.87-1.563-1.157h1.933l.597-1.871z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_4252_16188"
          x1="26.941"
          x2="26.941"
          y1="0"
          y2="21.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_4252_16188"
          x1="71.067"
          x2="71.067"
          y1="0"
          y2="32.044"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_4252_16188"
          x1="71.289"
          x2="71.289"
          y1="81.688"
          y2="60.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_4252_16188"
          x1="27.163"
          x2="27.163"
          y1="81.688"
          y2="60.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_4252_16188"
          x1="52.552"
          x2="52.552"
          y1="38.362"
          y2="66.694"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_4252_16188"
          x1="47.16"
          x2="47.16"
          y1="25.078"
          y2="31.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFEFC"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_4252_16188"
          x1="62.237"
          x2="62.237"
          y1="30.467"
          y2="45.135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_4252_16188"
          x1="35.111"
          x2="35.111"
          y1="21.212"
          y2="43.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_4252_16188"
          x1="49.67"
          x2="49.67"
          y1="63.185"
          y2="73.114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_4252_16188"
          x1="57.652"
          x2="57.652"
          y1="63.185"
          y2="68.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_4252_16188"
          x1="36.365"
          x2="36.365"
          y1="63.185"
          y2="68.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_4252_16188"
          x1="63.417"
          x2="63.417"
          y1="63.185"
          y2="68.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_4252_16188"
          x1="42.13"
          x2="42.13"
          y1="63.185"
          y2="68.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCAB00"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
